import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CommonForm from "../../utils/commonComponent/commonForm";
import axiosWithToken from "../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL } from "../../global";
import { CancelButton, SaveAndUpdate } from "../../utils/commonComponent/Custom/Button";
import { fetchQuery } from "../../utils/commonComponent/fetched";
import Text from "../../utils/commonComponent/Custom/text";
import { toast } from "react-toastify";
import { validateRequiredFields } from "../../utils/commonComponent/errorAlert";

const EditSetting = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [inputStates, setInputStates] = React.useState({});

  const updateInputObject = (key, value) => {
    setInputStates((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

   const inputFields = [
    { type: "TextField", label: "KeyName *", stateKey: "keyName" },
    { type: "Textarea", label: "Value *", stateKey: "value" },
  ];

  const fetchSettings = async () => {
    try {
      const [setting] = await fetchQuery(
        `select id, keyName, value from settings where id = ${params.id}`
      );
      setInputStates(setting);
    } catch (error) {
      console.error("Error fetching setting:", error);
    }
  };

  const onSubmit = async () => {
    // show alert
    const fieldsToValidate = [
      { value: inputStates.keyName, label: "keyName is reuqired" },
      { value: inputStates.value, label: "value is required" },
    ];
    
    if (!validateRequiredFields(fieldsToValidate)) {
      return;
    }

    try {
      const url = BASE_URL + `settings`;
      const { id, ...payload } = inputStates;
      params.id != 0
        ? await axiosWithToken.patch(url + `/${params.id}`, payload)
        : await axiosWithToken.post(url, payload);

      toast.success(
        params.id !== "0"
          ? "Setting Updated Successfully!"
          : "Setting Created Successfully!"
      );
      if (params.id == 0) {
        setTimeout(() => navigate("/master/settingList"), 1000);
      } else {
        setTimeout(() => window.location.reload(), 1000);
      }
    } catch (error) {
      console.error("Submission failed:", error);
    }
  };

  useEffect(() => {
    if (params.id != 0) {
      fetchSettings();
    }
  }, [params]);
  return (
    <>
      <Text variant="h3" bold className="text-blue-600">
        {params.id == 0 ? "Create New Setting" : "Update Setting"}
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={inputFields}
        colSpan={[1, 4]}
      />
      <br />
      <div className="flex gap-10 mt-5 justify-end ">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
          <SaveAndUpdate
            id="btn-add-outline"
            label={"Save"}
            onClick={onSubmit}
          />
      </div>
    </>
  );
};

export default EditSetting;
